import { type PropsWithChildren, createContext, useContext, useEffect, useMemo } from 'react'
import { useParams } from 'react-router'
import { KeywordDetailsStore } from 'pages/keywords/store'
import { useKeywordsPageContext } from './keywordsPageContext'

const KeywordDetailsContext = createContext<KeywordDetailsStore | null>(null)

export const useKeywordDetailsContext = () => {
  const context = useContext(KeywordDetailsContext)

  if (context === null)
    throw new Error('You have forgotten to wrap your root component with KeywordDetailsProvider')

  return context
}

export const KeywordDetailsProvider = ({ children }: PropsWithChildren) => {
  const { id } = useParams()
  const { pageLayoutStore, entities } = useKeywordsPageContext()
  const store = useMemo(() => new KeywordDetailsStore(id, pageLayoutStore, entities), [])

  useEffect(() => {
    void store.init()
    entities.inboxesStore.fetchInboxes()

    return store.dispose
  }, [])

  return <KeywordDetailsContext.Provider value={store}>{children}</KeywordDetailsContext.Provider>
}
